var map = {
	"./status-ACTIVE-icon.svg": "a7d4",
	"./status-DELETED-icon.svg": "e5c3",
	"./status-ERROR-icon.svg": "786e",
	"./status-PAUSED-icon.svg": "7f8e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "533e";